import type { AuthUser, AuthRole } from '../types/auth';

const VALID_ROLES: AuthRole[] = [
  'candidate',
  'hr',
  'admin',
  'recruiter',
  'operations',
  'manager',
];

export const normalizeUser = (user: unknown): AuthUser | null => {
  if (!user || typeof user !== 'object') return null;

  const rawUser = user as Record<string, unknown>;
  const lowerRole = typeof rawUser.role === 'string' ? rawUser.role.toLowerCase() : null;

  return {
    ...rawUser,
    role: VALID_ROLES.includes(lowerRole as AuthRole) ? (lowerRole as AuthRole) : null,
  } as AuthUser;
};